import { render } from "./PriceBatchEdit.vue?vue&type=template&id=49989eaa&scoped=true&ts=true"
import script from "./PriceBatchEdit.vue?vue&type=script&lang=ts"
export * from "./PriceBatchEdit.vue?vue&type=script&lang=ts"

import "./PriceBatchEdit.vue?vue&type=style&index=0&id=49989eaa&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49989eaa"]])

export default __exports__